const BASE_URL = 'https://desenv.taentregue.site/mobile/v1';

const apiFetch = async (url: string, options?: RequestInit) => {
  const response = await fetch(`${BASE_URL}${url}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData?.message || 'Erro na requisição');
  }

  return response.json();
};

export default apiFetch;
